import { actionTypes } from 'Actions/notificationTray'

export const NOTIFICATION_TABS = {
  UNREAD: 'unread',
  ALL: 'all',
}

const initialState = {
  isOpen: false,
  isFetching: false,
  isLoadingMore: false,
  lastFetch: null,
  notifications: [],
  activeTab: NOTIFICATION_TABS.UNREAD,
  currentPage: 1,
  hasMore: false,
  totalCount: 0,
  unreadTotalCount: null,
  loadingNotificationIds: [],
}

const notificationTray = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPEN_TRAY:
      return {
        ...state,
        isOpen: true,
      }
    case actionTypes.CLOSE_TRAY:
      return {
        ...state,
        isOpen: false,
      }
    case actionTypes.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
      }
    case actionTypes.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        ...action.payload,
      }
    case actionTypes.FETCH_MORE_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        isLoadingMore: true,
      }
    case actionTypes.FETCH_MORE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        isLoadingMore: false,
        notifications: [...state.notifications, ...action.payload.notifications],
        currentPage: action.payload.currentPage,
        hasMore: action.payload.hasMore,
      }
    case actionTypes.MARK_AS_READ_REQUEST:
    case actionTypes.MARK_AS_UNREAD_REQUEST:
      return {
        ...state,
        loadingNotificationIds: [...state.loadingNotificationIds, action.payload.id],
      }
    case actionTypes.MARK_AS_READ_SUCCESS:
      // Keep notification visible but mark as read, allowing user to undo
      return {
        ...state,
        loadingNotificationIds: state.loadingNotificationIds.filter((id) => id !== action.payload.id),
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload.id
            ? { ...notification, isUnread: false }
            : notification
        ),
        unreadTotalCount: state.unreadTotalCount !== null ? state.unreadTotalCount - 1 : null,
      }
    case actionTypes.MARK_AS_UNREAD_SUCCESS:
      return {
        ...state,
        loadingNotificationIds: state.loadingNotificationIds.filter((id) => id !== action.payload.id),
        notifications: state.notifications.map((notification) =>
          notification.id === action.payload.id
            ? { ...notification, isUnread: true }
            : notification
        ),
        unreadTotalCount: state.unreadTotalCount !== null ? state.unreadTotalCount + 1 : null,
      }
    case actionTypes.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
        notifications: [],
        currentPage: 1,
        hasMore: false,
      }
    case actionTypes.MARK_ALL_AS_READ_SUCCESS:
      return {
        ...state,
        notifications: state.activeTab === NOTIFICATION_TABS.UNREAD
          ? []
          : state.notifications.map((notification) => ({ ...notification, isUnread: false })),
        unreadTotalCount: 0,
      }
    default:
      return state
  }
}

export default notificationTray
